import { Suspense, lazy } from 'react';
import PageLoader from 'components/PageLoader';
import PageContainer from 'components/PageContainer';
import { AppRouteComponentProps } from 'components/AppRoutes';
import { usePageAccessible } from 'hooks';

const CusatData = lazy(() => import('./CusatData.component'));

export default function CusatDataPage(props: AppRouteComponentProps) {
  const hasAccess = usePageAccessible(props);

  return (
    <PageContainer hasAccess={hasAccess}>
      <Suspense fallback={<PageLoader open />}>
        <CusatData />
      </Suspense>
    </PageContainer>
  );
}
